import { FC, createContext, ReactNode } from "react";
import { Dispatch, SetStateAction, useContext } from "react";

type DiscountsRequestPayload = {
  name?: string;
  Page?: number;
  PageSize?: number;
  categoryCode?: string;
};

type DiscountsListingContextType = {
  filters: DiscountsRequestPayload;
  setFilters: Dispatch<SetStateAction<DiscountsRequestPayload>>;
};

const DiscountsListingContext = createContext<null | DiscountsListingContextType>(null);

const DiscountsListingProvider: FC<{ value: DiscountsListingContextType; children: ReactNode }> = ({ value, children }) => {
  return <DiscountsListingContext.Provider value={value}>{children}</DiscountsListingContext.Provider>;
};

const useDiscountsListing = () => {
  const context = useContext(DiscountsListingContext);
  if (!context) throw new Error("Illegal Usage of Context outside the DiscountsListingContext");
  return context;
};


export {DiscountsListingProvider,useDiscountsListing};